import { type UseQueryResult, useQuery } from 'react-query';
import {
  CustomerRoleService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_CustomerRoleListDto,
} from '../../services/wealthlane-customer-services';
import { type TableParamsType } from '../../types/common';

const useGetRoleList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType,
  filterCustomValue: string[]
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_CustomerRoleListDto | undefined,
  unknown
> => {
  const { filter, sorting, skipCount, maxResultCount } = tableInfo;
  const rolesData = useQuery(
    ['getRoles', filterCustomValue, filter, sorting, skipCount, maxResultCount],
    async () => {
      return await handleRequest(
        CustomerRoleService.getApiCustomerApiAppCustomerRoleCustomerRole(
          filterCustomValue,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return rolesData;
};

export default useGetRoleList;
